// This is not the correct way to import 3P javascript libraries.
//
// We added the https://github.com/blueimp/JavaScript-Load-Image plugin directly in our code to quickly resolve
// an issue with image uploads.
//
// TODO AUTHOR-4451: Remove this dir and import JavaScript-Load-Image via brazil
// TODO still unresolved after 4 years :). Please don't write technical debt in TODOs
module.exports = require('./load-image')

require('./load-image-scale')
